<template>
    <div>
        <b-row>
            <csp-desktop-firm-configurable-documents :cols="12" :context-id="firmAssociationId"
                context-type="firmAssociation" :form-context="dummyFormContext"/>
        </b-row>
    </div>
</template>

<script>
    import FirmConfigurableDocuments from '@desktop/components/FirmConfigurableDocuments.vue';
    import FormContext from '@desktop/components/FormContext';

    export default {
        name: 'FirmAssociationDocuments',
        components: {
            'csp-desktop-firm-configurable-documents': FirmConfigurableDocuments,
        },
        data() {
            const firmAssociationId = this.$route.params.firmAssociationId;
            return {
                firmAssociationId,
                // this form context only exists so that the form will render
                dummyFormContext: new FormContext({
                    name: 'firmAssociationDocuments',
                    objectId: firmAssociationId,
                    isLoaded: true,
                }),
            };
        },
    }
</script>
